var render = function render(){var _vm=this,_c=_vm._self._c;return _c('woot-tabs',{attrs:{"index":_vm.activeIndex},on:{"change":_vm.onTabChange}},_vm._l((_vm.tabs),function(tab){return _c('woot-tabs-item',{key:tab.routeName,attrs:{"name":tab.name,"show-badge":false}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }